if ( $(':radio[name="stats"]').length ) {

  $(function(){
    wpLocale = $('body').attr('data-wp-locale');

    //- country selection
    $(':radio[name="stats"]').change(function () {
      var val = $(this).filter(':checked').val();
      updateKeyFigures(val);
      updatePerfTables(val);
      updateDefaultTables(val);
      $("span.flag").removeClass('hidden').addClass('hidden');
      $("span.flag." + val).toggleClass('hidden');
    });

    updateKeyFigures('all');

  });
}
